export default "__VITE_ASSET__b3iJRR73__"